import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Home } from "lucide-react";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-tasktide-bg dark:bg-gray-900 font-sans flex flex-col">
      <Header />

      <main className="flex-1 flex items-center justify-center px-4 py-20">
        <div className="text-center max-w-2xl">
          <h1 className="text-9xl font-extrabold text-tasktide-blue opacity-20 mb-4">404</h1>
          <h2 className="text-4xl md:text-5xl font-bold text-tasktide-dark dark:text-white mb-6 -mt-12 relative z-10">
            Page Not Found
          </h2>
          <p className="text-xl text-gray-500 dark:text-gray-400 mb-10">
            Oops! The page you're looking for seems to have vanished into thin air.
            Let's get you back on track.
          </p>

          <Button
            onClick={() => navigate("/")}
            className="bg-optibiz-navy dark:bg-optibiz-orange text-white hover:bg-optibiz-navy/80 dark:hover:bg-optibiz-yellow rounded-full px-10 py-7 text-lg font-bold transition-all"
          >
            <Home className="mr-2 w-5 h-5" />
            Back to Home
          </Button>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default NotFound;
